
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo, servicioDocumental} from "../Configuracion";
import {
    CELLTIPO_CADENA,
    CELLTIPO_COLOR,
    CELLTIPO_ENTERO,
    CELLTIPO_FECHA,
    CELLTIPO_FOREIGN,
    CELLTIPO_ICONOACCION,
    CELLTIPO_ICONOACCION_DESCARGAR,
    CELLTIPO_ICONOACCION_ELIMINAR, CELLTIPO_IMAGENLISTA,
    COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import FormularioBotonera, {
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../framework2/adazzle/GridRDG";
import Titulo from "../../framework2/ej2/UI/Titulo";
import Tratamiento from "./Tratamiento";
import PropTypes from "prop-types";
import {
    asignarValoresCampo,
    COMPONENTE_TIPO_BOOL,
    COMPONENTE_TIPO_DATE,
    COMPONENTE_TIPO_FOREIGN, COMPONENTE_TIPO_FOREIGN_PANTALLA,
    COMPONENTE_TIPO_FOREIGN_SERVIDOR, COMPONENTE_TIPO_HTML,
    COMPONENTE_TIPO_INPUT, COMPONENTE_TIPO_MEMO,
    COMPONENTE_TIPO_SELECT,
    COMPONENTE_TIPO_SELECT_MULTI,
    loadDatos,
    loadDatosServicio,
    loadDatosURL,
    renderFormulario,
    renderGrid,
    showSelectBusqueda
} from "../utils/FormularioUtils";
import {dientes, tiposPagos, zonas} from "../utils/Definiciones";
import Paciente from "./Paciente";
import SelectorPeriodo from "../../framework2/ej2/UI/SelectorPeriodo";
import Pago from "./Pago";
import FileUploaderSimple from "../../framework2/ej2/UI/FileUploaderSimple";
import Dialogo from "../../framework2/blueprint/Dialogo";
import {descargarDocumento} from "../utils/DocumentosUtils";
import SelectorDocumentos from "../../framework2/ej2/UI/SelectorDocumentos";
import Pacientes from "./Pacientes";
import Documento from "./Documento";
import {loadServicioEntidad} from "../../framework2/ej2/utils/EntidadJPAUtils";
import {getFormattedDateFromTimestamp} from "../../framework2/ej2/utils/DateUtils";
import GaleriaImagenes from "../../framework2/ej2/UI/GaleriaImagenes";

export const DOCUMENTOS_MODO_GRID = 'DOCUMENTOS_MODO_GRID';
export const DOCUMENTOS_MODO_GALERIA = 'DOCUMENTOS_MODO_GALERIA';
export const DOCUMENTOS_MODO_TODO = 'DOCUMENTOS_MODO_TODO';

class Documentos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),

            //pacienteTratamientos: [],
        }
        this.esReducido= props.tratamiento != undefined && props.tratamiento != null;
        this.pacienteTratamientosCargados= false;

        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION, ancho: 40, visibilidad: COLUMNVISIBLE_SIEMPRE,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    console.log('this.pacienteTratamientosCargados: ', this.pacienteTratamientosCargados);
                    if (Boolean(this.pacienteTratamientosCargados))
                        this.setState({elementoSeleccionado: elemento, showGrid: false})
                }
            },
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_FECHA, ancho:140},
            {campo:"archivo", titulo: "Archivo", tipo: CELLTIPO_CADENA, ancho:200}];

        if (!this.esReducido)
            this.columnas.push(
                {campo:"diente", titulo: "Diente", tipo: CELLTIPO_CADENA, ancho:60},
                {campo:"tipos", titulo: "Tratamiento", tipo: CELLTIPO_CADENA, ancho:300});

        this.columnas.push(
            {campo:"observaciones", titulo: "Observaciones", tipo: CELLTIPO_CADENA, ancho:200},
            {campo:"descargar", tipo: CELLTIPO_ICONOACCION_DESCARGAR, ancho: 50, onAccion: this.descargarDocumento},
        );


        this.elementoConfig= {
            className: "Documento",
            secciones: [
                {
                    titulo: "Datos",
                    campos: [
                        {campo: "fecha", titulo: "Fecha", tipo: COMPONENTE_TIPO_DATE, cols: 1, obligatorio: true},
                        {campo: "archivo", titulo: "Archivo", tipo: COMPONENTE_TIPO_INPUT, cols: 3},
                        {campo: "pacienteCodigo.nombre", titulo: "Paciente", tipo: COMPONENTE_TIPO_INPUT, cols: 3, readonly: true},
                        {campo: "tratamientoCodigo", titulo: "Tratamiento", tipo: COMPONENTE_TIPO_FOREIGN, valores: [], cols: 3, obligatorio: true,
                            onCalcularOption: (option) => {
                                //console.log('option: ', option);
                                return getFormattedDateFromTimestamp(option.fecha) + ' - ' + option.tratamientoTipos;
                            }
                        },
                        {campo: "observaciones", titulo: "Observaciones", tipo: COMPONENTE_TIPO_MEMO, cols: 4, rows: 6},
                    ]
                },

            ]
        };
    }

    componentDidMount() {
        this.loadDatos();
    }

    loadDatos= () =>{
        const {paciente, tratamiento} = this.props;
        let parametros= {
            pacienteCodigo: paciente ? paciente.codigo : 0,
            tratamientoCodigo: tratamiento ? tratamiento.codigo : 0,
        }

        console.log("TRATAMIENTOS NUEVOS LOADDATOS");
        console.log("parametos: ", parametros);
        loadDatosServicio(this, "Documento", "getListaHM", parametros, () => {
            if (paciente)
                this.loadTratamientos();
        });
    }

    loadTratamientos= () =>{
        const {paciente} = this.props;
        if (!paciente)
            return;

        let parametros= {
            pacienteCodigo: paciente.codigo ? paciente.codigo : 0,
        }

        console.log('LOAD TRATAMIENTOS');
        loadServicioEntidad("Tratamiento", "getLista", parametros, (response) => {
            console.log(response);
            this.pacienteTratamientosCargados= true;
            asignarValoresCampo (this.elementoConfig, "Datos", "tratamientoCodigo", response);
            console.log('this.elementoConfig: ', this.elementoConfig);
        });
    }

    // ------------------------------------------------------------------------------------------------------------
    // DOCUMENTOS
    // ------------------------------------------------------------------------------------------------------------
    descargarDocumento= (documento) => {
        const {paciente, nombreClase} = this.props;
        console.log('documento: ', documento);
        descargarDocumento(nombreClase, paciente.codigo, documento);
    }
    documentoUploaded= (resultado, file) => {
        console.log(">>>>>>> Documento uploaded <<<<<<<" );
        console.log('resultado: ', resultado);
        console.log('file: ', file);
        this.guardarDocumentoBDD(resultado.fileName);
        //this.setState({marcaTiempoGrid: Date.now()});
        this.loadDatos();
    }
    documentoError= () => {
        alert("Error al enviar el archivo");
    }

    guardarDocumentoBDD= (nombreArchivo) => {
        const {auth, paciente, tratamiento} = this.props;

        let newDocumento= {
            codigo: 0,
            archivo: nombreArchivo,
            fecha: new Date(),
            documentotipoCodigo: 0,
            observaciones: '',
            pacienteCodigo: {codigo: paciente ? paciente.codigo : 9999},
            tratamientoCodigo: {codigo: tratamiento ? tratamiento.codigo : 9999}
            };


        let usuarioCodigo= auth.usuarioCodigo;
        let url= servidor + servicioRestfulMinimo + "Documento" + "/" + usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        console.log("url: ", url);
        console.log('neDocumento: ', newDocumento);
        clienteRestful.doPost(newDocumento, response => {
            let elementoGuardado= response;
            console.log("response: ", response);
            if (clienteRestful.exito && response) {
                console.log("Guardado!");
                this.loadDatos();
            }
        });

    }

    /* ----------------- ELIMINAR  ------------ */


    eliminarElemento= () => {
        const {elementoSeleccionado } = this.state;
        const {auth} = this.props;
        console.log(">>>eliminarElemento: ", elementoSeleccionado);
        let url= servidor + servicioRestfulMinimo + "Documento/" + elementoSeleccionado.codigo + "/0/"+ auth.usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete( response => {
            this.loadDatos();
        });
    }


    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
        }
    }

    onFormularioAceptado= () => {
        this.setState({showGrid: true}, this.loadDatos);
    }



    render() {
        const {showGrid, datos, elementoSeleccionado,
               dialogoTitulo, dialogoTexto, dialogoTipo, dialogoOnQuestion, dialogoOnClose} = this.state;
        const {paciente, tratamiento, nombreClase, modo} = this.props;

        let servicioUploadUrl= servidor + servicioDocumental + "upload/" +
            nombreClase + "/" + paciente.codigo + "/";

        let propiedadesGrid= {mostrarBotonera: false, height:300};
        if (this.esReducido)
            propiedadesGrid.height= 100;

        let mostrarGaleria= modo === DOCUMENTOS_MODO_TODO || modo === DOCUMENTOS_MODO_GALERIA;
        let mostrarGrid= modo === DOCUMENTOS_MODO_TODO || modo === DOCUMENTOS_MODO_GRID;

        console.log('paciente: ', paciente);
        console.log('tratamiento: ', tratamiento);
        return (
            <div style={{margin: 8, padding: 4}}>
                {/*!this.esReducido && <Titulo titulo="Gestión de Documentos" soloTitulo={true}/> */}
                {this.esReducido && <div className="fr_seccion_titulo">Documentos</div> }

                <Dialogo titulo={dialogoTitulo} mensaje={dialogoTexto} tipo={dialogoTipo}
                         onQuestion={dialogoOnQuestion}
                         onClose={dialogoOnClose}
                />




                {Boolean(showGrid) &&
                    <>
                        {mostrarGaleria &&
                            <GaleriaImagenes datos={datos} campoDescripcion={'tipos'} campoNombreArchivo={'archivo'} campoUrl={'url'} />
                        }

                        {mostrarGrid &&
                            <>
                                {renderGrid(this, "Documentos", datos, this.onAccion, propiedadesGrid)}
                                <FormularioBotonera
                                    numElementos={datos ? datos.length : 0}
                                    showAcciones={[BOTONERA_REFRESCAR]}
                                    onAccion={this.onAccion}
                                    elementoSeleccionado={elementoSeleccionado}
                                />
                                <SelectorDocumentos
                                    uploadUrl={servicioUploadUrl}
                                    onFileUploaded={this.documentoUploaded}
                                    onFileError={this.documentoError}
                                    acceptTypes={"image/jpeg,image/png,application/pdf"}
                                />
                            </>
                        }
                    </>
                }
                {!Boolean(showGrid) && renderFormulario(this, <Documento/>)}


            </div>
        )
    }

}

Documentos.propTypes = {
    nombreClase: PropTypes.string,
    paciente: PropTypes.object,
    tratamiento: PropTypes.object,
    llamador: PropTypes.object,
    modo: PropTypes.string,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Documentos);



